import { useTranslation } from 'react-i18next';

import { AdminBillingElement } from '@shared/dream-components';

import { useAdminBillingContext } from '~/context/SubscriptionManagement';

/**
 * Renders the admin / group billing fan-out on the Billing tab. Plans + loading state come from
 * `AdminBillingProvider` via context. Pure UI, no props, no data logic.
 */
export const AdminBillingSection = () => {
  const { t } = useTranslation();
  const { adminBillingPlans, isLoadingAdminBilling } = useAdminBillingContext();

  return (
    <div className="flex w-full flex-col gap-4">
      <AdminBillingElement
        element={{
          type: 'adminBilling',
          attrs: {
            data: { plans: adminBillingPlans },
          },
        }}
        isLive
        isLoading={isLoadingAdminBilling}
        translate={(key, vars) => t(key, vars)}
      />
    </div>
  );
};
